import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Swiper, { Pagination, Navigation, Autoplay } from 'swiper';
import defaultSwiperSettings from './defaultSwiperSettings';

var StandardSwipe = /*#__PURE__*/function () {
  function StandardSwipe(containerElement, additionalSettings, destroyBreakpoint) {
    _classCallCheck(this, StandardSwipe);

    this.containerElement = containerElement;
    this.sliderElement = this.containerElement.classList.contains('swiper') ? containerElement : containerElement.querySelector('.swiper');
    this.wrapper = this.sliderElement.querySelector('.swiper-wrapper');
    this.slides = this.sliderElement.querySelectorAll('.swiper-slide');
    this.swipeSettings = _objectSpread(_objectSpread({
      modules: [Navigation, Pagination, Autoplay]
    }, defaultSwiperSettings), additionalSettings);
    this.destroyBreakpoint = destroyBreakpoint;
    this.lastSize = true;
    this.standardSwiper = new Swiper(this.sliderElement, this.swipeSettings);
    this.onResize = this.onResize.bind(this);
  }

  _createClass(StandardSwipe, [{
    key: "toggleClasses",
    value: function toggleClasses() {
      this.sliderElement.classList.toggle('swiper');
      this.wrapper.classList.toggle('swiper-wrapper');
      this.slides.forEach(function (slide) {
        slide.classList.toggle('swiper-slide');
      });
    }
  }, {
    key: "onResize",
    value: function onResize() {
      var windowWidth = window.innerWidth;
      var isLarger = windowWidth > this.destroyBreakpoint;

      if (this.lastSize !== isLarger) {
        if (isLarger) {
          this.standardSwiper.destroy(true, true);
          this.toggleClasses();
        } else {
          this.toggleClasses();
          this.standardSwiper = new Swiper(this.sliderElement, this.swipeSettings);
          this.standardSwiper.init();
        }

        this.lastSize = isLarger;
      }
    }
  }, {
    key: "createResizeListener",
    value: function createResizeListener() {
      window.addEventListener('resize', this.onResize);
    }
  }, {
    key: "init",
    value: function init() {
      if (this.destroyBreakpoint) {
        if (!window.matchMedia("(min-width: ".concat(this.destroyBreakpoint, "px)")).matches) {
          this.lastSize = window.innerWidth > this.destroyBreakpoint;
          this.standardSwiper.init();
        } else {
          this.toggleClasses();
        }

        this.createResizeListener();
      } else {
        this.standardSwiper.init();
      }
    }
  }]);

  return StandardSwipe;
}();

export default StandardSwipe;